<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      offset-y
    >
      <template v-slot:activator="{ on }">
        <v-btn
          small
          elevation="0"
          light
          color="light"
          class="ml-1 text-capitalize"
          v-on="on"
        >
          <v-icon
            left
            dark
          >
            message
          </v-icon>
          Messages
        </v-btn>
      </template>

      <v-card>
        <v-list dense>
          <v-list-item>
            <v-list-item-content>
              <v-btn
                color="green"
                class="text-none white--text my-2 mb-2"
                small
                @click="showAdvancedFilters"
              >
                  <v-icon small class="mr-2">mdi-cloud-search</v-icon>
                Advanced Filters
              </v-btn>
              <v-btn
                color="light"
                class="text-none"
                small
                @click="messageAllDrivers"
              >
                Message All Drivers
              </v-btn>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-btn
                class="text-none"
                small
                @click="messageOnlineDrivers"
              >
                Message Online Drivers
              </v-btn>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-for="dg in driverGroups">
            <v-list-item-content>
              <v-btn
                class="text-none"
                small
                @click="function(){messageGroupDrivers(dg)}"
              >
                {{dg.name}} Drivers
              </v-btn>
            </v-list-item-content>
          </v-list-item>
<!--
          <v-list-item>
            <v-list-item-content>
              <v-btn
                color="light"
                class="text-none"
                small
              >
                <OnlineChannelsMenu />
              </v-btn>
            </v-list-item-content>
          </v-list-item>
-->
        </v-list>

        <v-divider />

        <v-flex px-1>
          <v-text-field
            v-model="filter"
            hide-details
            append-icon="search"
            placeholder="Search"
            @input="fetchActiveDriverIds"
          />
        </v-flex>
        <v-list
          v-if="localChannelsFiltered.length"
          class="overflow-y-auto"
          max-height="400"
        >
          <v-list-item
            v-for="channel in localChannelsFiltered"
            style="height: 24px"
          >
            <v-row justify="space-between">
              <div
                style="cursor: pointer"
                @click="openChannelFromList(channel)"
              >
                <p

                  style="fontsize: 12px"
                >
                  <b>{{ channel.friendlyName }}</b>
                </p>
              </div>
              <a
                v-if="contactNumberMap != null && contactNumberMap.length != 0"
                :href="
                  'tel:' +
                    formatNumber(
                      contactNumberMap[channel.sid]
                    )
                "
              >
                <v-btn
                  class="small-fab-phone"
                  icon
                  text
                >
                  <v-icon>phone</v-icon>
                </v-btn>
              </a>
            </v-row>
          </v-list-item>
        </v-list>
        <v-list>
        </v-list>
      </v-card>
    </v-menu>
    <div v-if="messageDialog">
      <v-dialog
        v-model="messageDialog"
        width="600px"
      >
        <MessageAllDriversDialog
          :online-only="onlineOnly"
          :group="group"
          @sent="sendMessageToAllDrivers"
        />
      </v-dialog>
    </div>
    <div v-if="advancedFiltersDialog">
      <v-dialog
        v-model="advancedFiltersDialog"
        width="1000"
      >
        <AdvancedMessageFiltersDialog
          :online-only="onlineOnly"
          :group="group"
          :twilio-channels="tc.localChannels"
          @close="advancedFiltersDialog = false"
          @sent="sendMessageToAllDrivers"
        />
      </v-dialog>
    </div>
  </div>
</template>

<script>

import {replaceStart} from "@/components/util/PhoneNumbers.js";
import MessageAllDriversDialog from "@/components/widget/menu/MessageAllDriversDialog.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
axios.defaults.withCredentials = true;
import moment from "moment";
import OnlineChannelsMenu from './OnlineChannelsMenu'
import AdvancedMessageFiltersDialog from '@/components/widget/menu/AdvancedMessageFiltersDialog.vue'

export default {
  name: "MessagingMenu",
  components: {
      AdvancedMessageFiltersDialog,
    MessageAllDriversDialog,
  },
  data: function () {
    return {
      driverGroups:[],
      showProgressBar: false,
      hideNavigation: false,
      contactNumberMap: null,
      onlineOnly: false,
      filter: "",
      menu: false,
      fullPage: true,
      openChat: false,
      accessToken: null,
      tc: {
        subscribedChannels: [],
        currentChannel: null,
        currentChannelMessages: null,
        activeChannels: [],
        localChannels: [],
      },
      prefix: "",
      messageList: [],
      identity: "",
      colors: {
        header: {
          bg: "#000000",
          text: "#ffffff",
        },
        launcher: {
          bg: "#000000",
        },
        messageList: {
          bg: "#ffffff",
        },
        sentMessage: {
          bg: "#4e8cff",
          text: "#ffffff",
        },
        receivedMessage: {
          bg: "#eaeaea",
          text: "#222222",
        },
        userInput: {
          bg: "#f4f7f9",
          text: "#565867",
        },
      },
      messageDialog: false,
      advancedFiltersDialog: false,
      activeDriverIDS: [],
      driversIDToContactNumber: {}
    };
  },
  computed: {
    loadingDialog() {
      return this.$store.getters['loadingDialog']
    },
    loggedIn: function () {
      return this.$store.getters.getLoggedIn;
    },
    name: function () {
      return this.$store.getters.getName;
    },
    driverToMessage: function () {
      return this.$store.state.driverToMessage;
    },
    localChannelsFiltered: function () {
      var filter = this.filter;

      var activeDriverIDS = this.activeDriverIDS;
      return this.tc.localChannels
          .filter(function (f) {
            if (filter == null || filter.length == 0) {
              return activeDriverIDS.indexOf(f.sid) > -1;
            }
            
            return (
                activeDriverIDS.indexOf(f.sid) > -1 &&
                f.friendlyName.toLowerCase().includes(filter.toLowerCase())
            );
          })
          .sort(function (a, b) {
            return a.friendlyName
                .split(" ")[1]
                .localeCompare(b.friendlyName.split(" ")[1]);
          });
    },
  },
  watch: {
    localChannelsFiltered () {
      if (this.localChannelsFiltered.length == 0) {
        // this.showProgressBar = false
      }
    }
  },
    created() {
        this.loadData()
    },
    mounted: function () {
/*
    this.$store.state.driverToMessage = null;
    this.fetchAccessToken();
    this.fetchActiveDriverIds();
*/
    setTimeout(this.getDriverGroups, 300);
  },
  methods: {
    getDriverGroups: async function() {
      try {
        var url = `${this.$store.state.apiUrl}/driver_group/all`;

        let response = await axios.get(url, {
          params: {}
        });

        this.driverGroups = response.data;
      } catch (e) {
        console.log(e);
      }
      
    },
    async loadData () {
      this.$store.state.driverToMessage = null;
      this.fetchAccessToken();
      this.fetchActiveDriverIds();
    },
    formatNumber: function (number) {
      return replaceStart(number);
    },
    showAdvancedFilters() {
      this.advancedFiltersDialog = true;
    },
    messageAllDrivers() {
      this.group = null;
      this.onlineOnly = false;
      this.messageDialog = true;
    },
    messageOnlineDrivers() {
      this.group = null;
      this.onlineOnly = true;
      this.messageDialog = true;
    },
    messageGroupDrivers(group) {
      this.group = group;
      this.messageDialog = true;
    },
    openChannelFromList(channel) {
      this.menu = false;
      this.driverChannelSelected(channel);
    },
    openChatFromBeautifulChat() {
      this.openChat = true;
    },
    async fetchActiveDriverIds() {
      var url = `${this.$store.state.apiUrl}/chat/getChannelsForDrivers?onlineOnly=${this.onlineOnly}`;
      
      // if (this.filter) {
      //     url += `&filter=${this.filter}`
      // }
      
      let response = await axios.get(url, {
        params: {},
      });
      // this.showProgressBar = false

      if (response.data.error == "no_error") {
        var ids = response.data.channelSids;
        this.activeDriverIDS = ids;
        this.contactNumberMap = response.data.contactNumberMap
      }
    },
    async sendMessageToAllDrivers(message) {
      try {
        var url = `${this.$store.state.apiUrl}/chat/getChannelsForDrivers?onlineOnly=${this.onlineOnly}`;

        if (this.group != null) {
            url+=`&driverGroupId=${this.group.id}`
        }


        let response = await axios.get(url, {
          params: {},
        });

        if (response.data.error == "no_error") {
          var ids = response.data.channelSids;

          var tc = this.tc;

          for (var i = 0; i < this.tc.subscribedChannels.length; i++) {
            const lc = this.tc.subscribedChannels[i];

            var oldMessages =
                lc.lastMessage != null &&
                lc.lastReadMessage < lc.lastMessage.index;

            if (ids.indexOf(lc.sid) >= 0) {
              if (!oldMessages) {
                lc.sendMessage(message).then(function (m) {
                  lc.setAllMessagesRead();
                });
              }
            } else {
            }
          }
        } else {
          alert("Error sending to all drivers");
        }

        this.loading = false;
      } catch (error) {
        alert("Error sending to all drivers");
        this.loading = false;
      }

      this.messageDialog = false;
    },
    colorForChannel(c) {
      if (
          c.lastMessage != null &&
          c.lastReadMessage < c.lastMessage.index
      ) {
        return "blue lighten-2";
      } else {
        return "grey lighten-2";
      }
    },
    driverChannelSelected(channel) {
      this.filter = "";

      var driverIDString = channel.uniqueName.replace(this.prefix, "");

      var driverID = Number(driverIDString);

      this.$store.state.driverToMessage = driverID;
    },
    closeChannel(channel) {
      for (var i = 0; i < this.tc.activeChannels.length; i++) {
        var activeChannel = this.tc.activeChannels[i];

        if (activeChannel.sid == channel.sid) {
          this.tc.activeChannels.splice(i, 1);
        }
      }

      if (
          this.tc.currentChannel != null &&
          this.tc.currentChannel.sid == channel.sid
      ) {
        this.closeChat();
      }
    },
    closeChat() {
      this.openChat = false;
      this.$store.state.driverToMessage = null;
      var channel = this.tc.currentChannel;
      this.tc.currentChannel = null;

      // for (var i = 0; i < this.tc.activeChannels.length; i++) {
      //   var activeChannel = this.tc.activeChannels[i];

      //   if (activeChannel.sid == channel.sid) {
      //     this.tc.activeChannels.splice(i, 1);
      //   }
      // }
    },
    async fetchAccessToken() {
      try {
        var url = `${this.$store.state.apiUrl}/chat/getAuthToken`;

        let response = await axios.get(url, {
          params: {},
        });

        if (response.data.accessToken != null) {
          this.accessToken = response.data.accessToken;
          this.prefix = response.data.prefix;
          this.identity = response.data.identity;

          if (this.tc.messagingClient == null) {
            this.initialiseChat(this.accessToken);
          } else {
            this.setNewToken(this.accessToken);
          }
        } else {
          setTimeout(this.fetchAccessToken, 2000);
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        setTimeout(this.fetchAccessToken, 2000);
      }
    },
    messageSent: function (msg) {
      var self = this;
      this.tc.currentChannel.sendMessage(msg.data.text).then(function (m) {
      });
    },
    initialiseChat: function (token) {
      var tc = this.tc;


      var self = this;

      Twilio.Conversations.Client.create(token)
          .then(function (client) {
            // console.log("Connected to chat");
            tc.messagingClient = client;
            tc.messagingClient.on(
                "tokenAboutToExpire",
                self.refreshToken.bind(this)
            );
            tc.messagingClient.on("tokenExpired", self.refreshToken.bind(this));

            tc.messagingClient.on("messageAdded", function (m) {

              if (
                  m.author != self.identity &&
                  (self.tc.currentChannel == null ||
                      m.conversation.sid != self.tc.currentChannel.sid)
              ) {
                var thissound = document.getElementById("ding");
                thissound.currentTime = 0;
                thissound.play();
              }
            });

            tc.messagingClient.on("conversationUpdated", function (cu) {
              var c = cu.conversation;

              if (
                  !(tc.currentChannel != null && tc.currentChannel.sid == c.sid)
              ) {
                if (
                    c.lastMessage != null &&
                    c.lastReadMessage < c.lastMessage.index
                ) {


                  if (
                      !self.tc.activeChannels.some(function (activeChannel) {
                        return activeChannel.sid == c.sid;
                      })
                  ) {

                    c.getMessages(1).then(function (messages) {



                      var ml = [];

                      for (var i = 0; i < messages.items.length; i++) {
                        var msg = messages.items[i];

                        if (msg.author == self.identity) {
                          // c.setAllMessagesConsumed();
                        } else {
                          self.tc.activeChannels.push(c);
                        }
                      }
                    });
                  } else {

                  }
                } else {

                  for (var i = 0; i < tc.activeChannels.length; i++) {
                    const activeChannel = tc.activeChannels[i];

                    if (activeChannel.sid == c.sid) {
                      tc.activeChannels.splice(i, 1);
                    }
                  }
                }
              } else {
              }
            });

            tc.messagingClient.on("messageAdded", function (msg) {
              if (
                  tc.currentChannel != null &&
                  msg.conversation.sid == tc.currentChannel.sid
              ) {
                self.messageList.push({
                  author: msg.author == self.identity ? "me" : msg.author,
                  type: "text",
                  id: msg.sid,
                  data: {
                    text: msg.body,
                    meta: moment(msg.timestamp).format("YYYY-MM-DD HH:mm"),
                  },
                  index: msg.index,
                });

                tc.currentChannel.setAllMessagesRead();
              }
            });

            // get list of all subscribed channels
            client.getSubscribedConversations().then(function (paginator) {
              self.fetchChannels(paginator);
            });
            // listen for events on all of these channels
            // when added to a channel subscribe to it (new drivers for example)
            //
          })
          .catch(function (e) {
          });
    },
    fetchChannels(paginator) {
      for (var i = 0; i < paginator.items.length; i++) {
        var channel = paginator.items[i];

        this.tc.subscribedChannels.push(channel);

        if (channel.lastMessage == null) {
          // console.log("LAST MESSAGE NULL");
        }

        if (
            channel.lastMessage != null &&
            channel.lastMessage.index >
            channel.lastReadMessage
        ) {

          var self = this;

          channel.getMessages(1).then(function (messages) {

            var ml = [];

            for (var i = 0; i < messages.items.length; i++) {
              var msg = messages.items[i];

              if (msg.author == self.identity) {
                channel.setAllMessagesRead();
              } else {
                self.tc.activeChannels.push(channel);
              }
            }
          });
        }
      }

      var self = this;
      var tc = this.tc;

      if (paginator.hasNextPage) {
        // console.log("Paginator has next page so fetch");
        paginator.nextPage().then(function (p) {
          // console.log("Next page");
          // console.log(p);
          self.fetchChannels(p);
        });
      } else {
        // console.log("Paginator fully iterated");

     
        self.tc.localChannels = self.tc.subscribedChannels;
      }
    },
    refreshToken() {
      this.fetchAccessToken();
    },
    setNewToken(token) {
      var self = this;
      this.tc.messagingClient
          .updateToken(token)
          .then(function (success) {
          })
          .catch(function (e) {
            setTimeout(function () {
              self.fetchAccessToken();
            }, 1500);
          });
    },
  },
};
</script>

<style scoped>

</style>